const TitleToSlug = (Text) => {
  return Text.toLowerCase()
             .replace(/ /g, '-')
             .replace(/[^\w-]+/g, '');
}
export default TitleToSlug